import { createStore } from 'vuex'
// import ApiService from "../services"
import axios from 'axios';
export default createStore({
    state: {
        stakes: null,
        woods: null,
        metals: null,
        loaded: false,
        leathers: null,
        balance: 0,
        weapons: null,
        recipes: null,
        weaponTemplates: null,
    },
    actions: {
        // getBalance: function({ commit }) {
        //     return axios
        //         .post(`${process.env.VUE_APP_CHAIN_API}/get_account`, { account_name: localStorage.getItem("wax_user") })
        //         .then((res) => {
        //             // commit("addBalance", res.data.core_liquid_balance);
        //         })
        // },
        getMaterials: function({ commit }) {
            let username = localStorage.getItem("wax_user");
            return axios
                .get(
                    `${process.env.VUE_APP_API_ASSET_URL}?owner=${username}&collection_name=weapsmithing&schema_name=material&page=1&limit=1000`
                )
                .then((response) => {
                    let res = response["data"].data;
                    if (res.length) {
                        let metals = [];
                        let leathers = [];
                        let woods = [];
                        for (let i = 0; i < res.length; i++) {
                            const row = res[i];
                            if (row.name == "Metal") {
                                metals.push(row);
                            } else if (row.name == "Leather") {
                                leathers.push(row);
                            } else if (row.name == "Wood") {
                                woods.push(row);
                            }
                        }
                        commit("addWood", woods);
                        commit("addMetal", metals);
                        commit("addLeather", leathers);
                    }
                }).then(() => commit("isLoaded", true));
        },
        getRecipes: function({ commit }) {
            let username = localStorage.getItem("wax_user");
            return axios
                .get(
                    `${process.env.VUE_APP_API_ASSET_URL}?owner=${username}&collection_name=weapsmithing&schema_name=recipe&page=1&limit=1000`
                )
                .then((response) => {
                    let res = response["data"].data;
                    if (res.length) {
                        commit("addRecipes", res);
                    }
                });
        },
        getWeapons: function({ commit }) {
            let username = localStorage.getItem("wax_user");
            return axios
                .get(
                    `${process.env.VUE_APP_API_ASSET_URL}?owner=${username}&collection_name=weapsmithing&schema_name=weapon&page=1&limit=1000`
                )
                .then((response) => {
                    let res = response["data"].data;
                    if (res.length) {
                        commit("addWeapons", res);
                    }
                });
        },
        getTemplates: function({ commit }) {
            let weaponSchema = process.env.VUE_APP_WEAPON_SCHEMA;
            return axios
                .get(
                    `${process.env.VUE_APP_API_TEMPLATE_URL}?&collection_name=weapsmithing&schema_name=${weaponSchema}&page=1&limit=1000`
                )
                .then((response) => {
                    let res = response["data"].data;
                    if (res.length) {
                        commit("addWeaponTemplates", res);
                        commit("isLoaded", true);
                    }
                });
        },
    },
    mutations: {
        addWeapons: (state, payload) => {
            if (payload) {
                return state.weapons = payload;
            }
        },
        addRecipes: (state, payload) => {
            if (payload) {
                return state.recipes = payload;
            }
        },
        addBalance: (state, payload) => {
            if (payload) {
                return state.balance = payload;
            }
        },
        addWeaponTemplates: (state, payload) => {
            if (payload) {
                return state.weaponTemplates = payload;
            }
        },
        addStake: (state, payload) => {
            if (payload) {
                return state.stakes = payload;
            }
        },
        addWood: (state, payload) => {
            if (payload) {
                return state.woods = payload;
            }
        },
        isLoaded: (state, payload) => {
            state.loaded = payload;
        },
        addMetal: (state, payload) => {
            if (payload) {
                return state.metals = payload;
            }
        },
        addLeather: (state, payload) => {
            if (payload) {
                return state.leathers = payload;
            }
        },
        updateAssets: (state, recipe) => {
            state.woods.shift();
            state.leathers.shift();
            state.metals.shift();
            state.recipes = state.recipes.filter(x => x.asset_id !== recipe);
            // state.recipes.shift();
        }
    },
    getters: {
        balance: state => {
            if (state.balance) {
                return state.balance.balances;
                // return new Intl.NumberFormat().format(numberVal)
            }
            return 0;
        },
        mcc: state => {
            if (state.balance) {
                let numberVal = state.balance.balances;
                let val = numberVal.filter((row) => row.key == "4,MCC");
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        wsw: state => {
            if (state.balance) {
                let numberVal = state.balance.balances;
                let val = numberVal.filter((row) => row.key == "4,WSW");
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        wsl: state => {
            if (state.balance) {
                let numberVal = state.balance.balances;
                let val = numberVal.filter((row) => row.key == "4,WSL");
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        wsm: state => {
            if (state.balance) {
                let numberVal = state.balance.balances;
                let val = numberVal.filter((row) => row.key == "4,WSM");
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        stakes: state => state.stakes,
        // woods: state => state.woods,
        leathers: state => state.leathers,
        metals: state => state.metals,
        woods: state => state.woods,
        coins: state => {
            if (state.mcc[0].value) {
                return state.mcc[0].value / 10000
            }
            return 0;
        },
        loaded: state => state.loaded,
        // metals: state => state.metals,
        weaponTemplates: (state) => {
            if (state.weaponTemplates) {
                const ids = state.weaponTemplates.map(o => o.immutable_data.name);
                return state.weaponTemplates.filter(({ immutable_data }, index) => !ids.includes(immutable_data.name, index + 1));
            }
        },
        recipes: state => state.recipes,
        requiredRecipe: (state) => (name) => {
            return state.recipes.filter(item => item.name.includes(name));
        },
        weapons: state => state.weapons,
    }
})